import React, { FC } from 'react'

import { ChartItem } from 'modules/Charts/components'

import { IChartsRowProps } from './ChartsRow.props'

const ChartsRow: FC<IChartsRowProps> = ({ factSources, index, row, columnsLength, assignedСampaigns }) => (
  <>
    {factSources.map((factSource, sourceIndex) => (
      <ChartItem
        key={`chartsItem__${index}_${sourceIndex}`}
        index={index}
        factSource={factSource}
        row={row}
        columnsLength={columnsLength}
        assignedСampaigns={assignedСampaigns}
      />
    ))}
  </>
)

export default ChartsRow
